<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full"> توضیحات و نتیجه </span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <!-- <v-col cols="12">
            <v-row>
              <span>احیا</span>
              <v-divider class="mt-3 mr-3"></v-divider>
            </v-row>
            <v-radio-group v-model="patientTechnicianDrugCooperationTypeValue">
              <v-row>
                <v-col
                  cols="4"
                  v-for="(item, index) in allRevivalsList"
                  :key="index"
                >
                  <v-radio v-bind="item"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col> -->
      <v-col cols="6">
        <v-row>
          <span>سایر توضیحات</span>
          <v-divider class="mt-3 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea label="توضیحات *" dense rows="7" outlined clearable clear-icon="mdi-close-circle-outline"
              v-model="patientResult.note" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <span>نتیجه</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete hide-details :items="allResultBaseDataWithPatient" no-data-text="اطلاعاتی وجود ندارد" dense
              @change="resultChange()" outlined item-text="title" item-value="id" label="نتیجه *" clearable
              clear-icon="mdi-close-circle-outline" v-model="patientResult.resultId" autocomplete="off"
              prepend-inner-icon="mdi-needle mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="patientResult.resultId === 1" class="mt-n3">
            <v-autocomplete hide-details :items="allToOtherCodes" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="value" label="محل تحویل بیمار" clearable
              clear-icon="mdi-close-circle-outline" v-model="patientResult.information" autocomplete="off"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="patientResult.resultId === 4">
            <v-autocomplete :items="allDeath" no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title"
              item-value="value" label="نوع مرگ" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientResult.information" autocomplete="off"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="patientResult.resultId === 3" class="mt-n3">
            <v-text-field dense outlined label="کد برائت نامه دریافتی" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientResult.information" autocomplete="off"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
          </v-col>
          <template v-if="patientResult.resultId === 5">
            <v-col cols="12">
              <v-autocomplete hide-details :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                outlined item-text="title" item-value="value" label="نوع کد" clearable
                clear-icon="mdi-close-circle-outline" v-model="patientVehicleType" autocomplete="off"
                prepend-inner-icon="mdi-text-box mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n3">
              <v-text-field hide-details dense outlined label="کد" clearable clear-icon="mdi-close-circle-outline"
                v-model="patientVehicleCode" autocomplete="off"
                prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
            </v-col>
          </template>
          <v-col cols="12" v-if="patientResult.resultId === 12">
            <v-autocomplete hide-details :items="endOfLifeInformation" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="title" label="ختم احیا" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientResult.information" autocomplete="off"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="finish()">ثبت</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">انصراف</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep14Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep14Helper.js';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin';
import PatientResultMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientResultMixin.js';
import ResultBaseDataMixin from '@/Mixins/BaseInformation/ResultBaseDataMixin';
export default {
  mixins: [
    FollowUpPatientStep14Helper,
    ShearedMixin,
    SharedHelper,
    VehicleTypeMixin,
    PatientResultMixin,
    ResultBaseDataMixin,
  ],
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getListOfVehicleTypesForOther();
      this.getPatientResultByIdFunction(this.patientId);
      this.getAllResultBaseDatasWithPatientFunction();
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    }
  },
};
</script>
<style scoped></style>
